import React, { useState } from 'react';

import { VideoScreenLayout } from './VideoScreenLayout/VideoScreenLayout';
import { VideoScreenModal } from './VideoScreenModal/VideoScreenModal';
import VideoOld from './OldProvider/Video.old';
import { VIDEO_SELFIE } from 'constants/identityMethod';
import { i18n } from 'core/i18n';

const { formatText } = i18n;
import exitIcon from 'assets/icons/icon-exit.svg';
import { VIDEOSELFIE_CAPTURE } from 'constants/featureFlagging';
import { VideoSelfie } from './VideoSelfie/VideoSelfie';
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import { isIos, isMacOS, isMobile } from 'utilities/browser';
import { LEAVE } from 'constants/video/status';
import { LocalStorageStorage } from 'utilities/Storage/LocalStorageStorage';

const initialState = {
    showModal: false,
    statusCode: LEAVE,
    statusNumber: 0,
    videoselfieComponentKey: 0,
};
export const VideoScreenDispatcher = ({
    flags,
    identityType,
    videoUrl,
    userProfile,
    leaveModalTag,
    handlePrevious,
    onFinishVideoSelfie,
}) => {
    const [
        { showModal, statusCode, statusNumber, documentType, videoselfieComponentKey },
        setVideoScreenDispatcherState,
    ] = useState(initialState);

    const isVideoSelfieType = identityType === VIDEO_SELFIE;

    const handleRetry = () => {
        if (isIos() && !isMacOS()) {
            location.reload();
        } else {
            setVideoScreenDispatcherState(prevState => ({
                ...prevState,
                ...initialState,
                videoselfieComponentKey: prevState.videoselfieComponentKey + 1,
            }));
        }
    };

    const handleModal = (open, statusCode, statusNumber, documentType) => {
        setVideoScreenDispatcherState(prevState => ({
            ...prevState,
            statusCode,
            showModal: open,
            statusNumber,
            documentType,
        }));
    };

    const leaveModalOpen = () => {
        leaveModalTag();
        handleModal(true, LEAVE);
    };

    const isVeridasVideoSelfieActive = () => {
        return isVideoSelfieType && flags.get(VIDEOSELFIE_CAPTURE);
    };

    const renderModal = () => (
        <VideoScreenModal
            userProfile={userProfile}
            showModal={showModal}
            statusCode={statusCode}
            statusNumber={statusNumber}
            documentType={documentType}
            identityType={identityType}
            leaveModalTag={leaveModalTag}
            handlePrevious={handlePrevious}
            handleRetry={handleRetry}
            handleModal={handleModal}
        />
    );

    const renderFooter = () => {
        if (isMobile() && isVeridasVideoSelfieActive()) {
            return null;
        }

        return (
            <RoadmapNavigation
                buttonPrevHidden
                buttonFinalizeAndContinueHidden
                buttonCancelAction={leaveModalOpen}
                buttonCancelText={
                    <div className="cancel-container">
                        <img src={exitIcon} alt="arrow-left" />
                        <span>{formatText(isVideoSelfieType ? 'button-exitVideoselfie' : 'button-exitVideocall')}</span>
                    </div>
                }
            />
        );
    };

    const renderContent = () => {
        const { acceptedText } = userProfile;
        if (isVeridasVideoSelfieActive()) {
            const handleIdentificationError = ({ statusCode, code, documentType }) => {
                if (!code) handleModal(true, statusCode, undefined, documentType);
                handleModal(true, statusCode, code, documentType);
            };
            const storage = LocalStorageStorage();
            const isFaceMatchActive = storage.get('identification')?.isSelectedVideoselfieWithBiometrics ?? true;

            return (
                <VideoSelfie
                    key={videoselfieComponentKey}
                    acceptedText={acceptedText}
                    faceMatch={isFaceMatchActive}
                    onIdentificationError={handleIdentificationError}
                    onIdentificationSuccess={onFinishVideoSelfie}
                    handleModal={handleModal}
                />
            );
        }

        return (
            <VideoOld
                userProfile={userProfile}
                isVideoCallType={!isVideoSelfieType}
                identityType={identityType}
                videoUrl={videoUrl}
                handleModal={handleModal}
                onFinishVideoSelfie={onFinishVideoSelfie}
            />
        );
    };

    return (
        <VideoScreenLayout renderFooter={renderFooter} renderModal={renderModal}>
            {renderContent()}
        </VideoScreenLayout>
    );
};
